
<template>
  <div class="row">
    <div class="col-md-12">
      <div class="pbottom-20">
        <field field-class="col-xs-12 col-sm-5 col-md-4 col-lg-4 no-padding select-white float-left" type="select" :value="filters.datestart" :options="monthList" v-on:input="refreshMonth"></field>
        <a :href="printReport()" target="_blank"><button type="button" class="mleft-20 float-right btn btn-primary" :disabled="isCurrentMonth"><i class="fa fa-download"></i> {{ $t('Invoices.monthlyStatement') }}</button></a>
        <div class="clear"></div>
      </div>
      <card body-class="no-padding table-responsive">
        <pagedlist
          :offset="filters.offset"
          :limit="filters.limit"
          :count="filters.count"
          :pages="filters.pages"
          v-on:refresh="refresh"
        >
          <table class="datatable table table-striped primary dataTable no-footer">
            <thead>
              <tr>
                <th>{{ $t('Invoices.invoiceNum') }}</th>
                <th>{{ $t('Common.date') }}</th>
                <th class="a-r">{{ $t('Common.amount') }}</th>
                <th v-if="!hideInvoiceStatus">{{ $t('Common.status') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in table.body">
                <td>
                  <a :href="printUrl(row)" target="_blank"><i class="fa fa-file-pdf-o" aria-hidden="true"></i> {{ row.transactionnum }}</a>
                </td>
                <td>{{ row.date | formatDate }}</td>
                <td class="a-r">{{ (row.netamount + row.tax) | formatCurrency }}</td>
                <td v-if="!hideInvoiceStatus">
                  <invoice-status-badge :status="row.status"/>
                </td>
              </tr>
            </tbody>
          </table>
        </pagedlist>
      </card>
    </div>
  </div>
</template>
<script>
import InvoiceStatusBadge from '../Elements/InvoiceStatusBadge'

var view = require('../view.js'),
    viewData = {
      filters: {
        offset: 0,
        limit: 20,
        count: 0,
        pages: 0,
        datestart: null,
        dateend: null,
        type: 3
      },
      table: {
        body: []
      },
      monthList: [
        /*{
          label: 'Mai 2017',
          value: 1493589600
        },
        {
          label: 'April 2017',
          value: 1490997600
        },
        {
          label: 'März 2017',
          value: 1488322800
        }*/
      ]
    };

export default view(viewData, {
  components: {
    InvoiceStatusBadge
  },
  computed: {
    isCurrentMonth() {
      // Disable button for the current month
      var date = new Date(viewData.filters.datestart * 1000);
      var now = new Date();
      return date.getFullYear() === now.getFullYear() && date.getMonth() === now.getMonth();
    },
    hideInvoiceStatus() {
      return typeof this.$root.hideInvoiceStatus == 'undefined' ? false : this.$root.hideInvoiceStatus;
    }
  },
  mounted() {
    this.$parent.viewTitle = this.$t('Invoices.title');

    //var now = new Date();
    //var datestart = new Date(now.getFullYear(), now.getMonth(), 1);
    //viewData.filters.datestart = datestart.getTime() / 1000;
    viewData.filters.offset = 0;

    this.$http.get(this.$root.url + 'transaction/', {params: viewData.filters}).then(function(res) {
        let months = {};
        for (let i=0; i<res.data.result.data.length; i++) {
          let trans = res.data.result.data[i];
          let date = new Date(trans.date * 1000);
          let datestart = new Date(date.getFullYear(), date.getMonth(), 1).getTime() / 1000;
          months[datestart] = date;
        }
        //months = months.sort();
        //console.log("MONTHS", months);
        viewData.monthList.slice(0, viewData.monthList.length);
        for (var datestart in months) {
          var date = months[datestart];
          viewData.monthList.push({label: ("0" + (date.getMonth()+1)).slice(-2) + ' / ' + date.getFullYear(), value: datestart});
        }
        viewData.filters.datestart = datestart;

        this.refresh();
      }.bind(this),
      function(res) {
        viewData.table.body = [];
        console.log('Fail', res);
      }.bind(this));
  },
  methods: {
    refresh(offset, datestart, dateend) {
      if (offset != null)
        viewData.filters.offset = offset;

      if (!(typeof datestart == 'undefined')) {
        viewData.filters.datestart = datestart;
      }

      if (!(typeof dateend == 'undefined')) {
        viewData.filters.dateend = dateend;
      }

      this.$http.get(this.$root.url + 'transaction/', {params: viewData.filters}).then(function(res) {
          viewData.table.body = res.data.result.data;
          viewData.filters.count = res.data.result.count;
          viewData.filters.offset = res.data.result.offset;
          viewData.filters.limit = res.data.result.limit;
          viewData.filters.pages = res.data.result.pages;
        }.bind(this),
        function(res) {
          viewData.table.body = [];
          console.log('Fail', res);
        }.bind(this));
    },
    refreshMonth(datestart) {
      var dateend = null; // TODO Calculate the end date
      this.refresh(0, datestart, dateend);
    },
    printUrl(order) {
      return this.$root.url + 'transaction/' + order.ID + '/print/' + order.transactionnum + '.pdf';
    },
    printReport() {
      var datefrom = new Date(viewData.filters.datestart * 1000);
      return this.$root.url + 'transaction/report/' + datefrom.getFullYear() + '/' + (datefrom.getMonth()+1) + '/report.pdf';
    }
  }
});
</script>
